import { Injectable } from '@angular/core';
import { BaseStoreRepository } from '../base-store.repository';
import { currentTasksInitialState, CurrentTasksStateProps, currentTasKStateStore } from './current-tasks-state.store';
import { select } from '@ngneat/elf';

@Injectable({
  providedIn: 'root',
})
export class CurrentTasksRepository extends BaseStoreRepository<CurrentTasksStateProps> {
  constructor() {
    super(currentTasKStateStore.pipe(select(state => state)), currentTasKStateStore, currentTasksInitialState);
  }
}
